module.exports = __webpack_public_path__ + "img/xxfhbig.97b4a7ba.png";